/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import {
  Typography,
  makeStyles,
  Theme,
  createStyles,
  IconButton,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { ConnectionConfigDataRow } from "../../../../types/config";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    root: {
      fontSize: 13,
    },
    typography: {
      fontSize: "0.875rem",
    },
    passwordVisibilityIconButton: {
      padding: "0.25rem",
    },
  })
);

interface Props {
  rowData: ConnectionConfigDataRow;
  handleVisibilityChange: () => void;
}

/** 認証ユーザー名 / パスワード表示コンポーネント */
export function UsernameAndPasswordRenderComponent(props: Props) {
  const classes = useStyles();

  const { rowData, handleVisibilityChange } = props;

  //--------------------
  // コンポーネント
  return (
    <>
      <div>
        <Typography className={classes.typography} component="span">
          {rowData.usernameAndPassword.username
            ? rowData.usernameAndPassword.username
            : "未登録"}
        </Typography>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        {/*
          パスワード

        */}
        {rowData.usernameAndPassword.password.renderVisible ? (
          <Typography component="span" className={classes.typography}>
            {rowData.usernameAndPassword.password.value}
          </Typography>
        ) : (
          <Typography component="span" className={classes.typography}>
            ●●●●●●●●
          </Typography>
        )}
        {/*
          表示/非表示 切替アイコン

        */}
        <IconButton
          aria-label="toggle password visibility"
          className={classes.passwordVisibilityIconButton}
          onClick={handleVisibilityChange}
          onMouseDown={(event: React.MouseEvent<HTMLButtonElement>) => {
            event.preventDefault();
          }}
        >
          {rowData.usernameAndPassword.password.renderVisible ? (
            <Visibility />
          ) : (
            <VisibilityOff />
          )}
        </IconButton>
      </div>
    </>
  );
}
